module.exports = __webpack_public_path__ + "img/people.519b60be.png";